import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-diy-category-list-accordion',
  template: `
<ngb-accordion
  class="diy-category-list-accordion"
  [closeOthers]="true"
  [destroyOnHide]="false"
  (panelChange)="onPanelChange($event)"
>
  <ngb-panel *ngFor="let category of categories; let i = index">
    <ng-template ngbPanelTitle>
      <span class="input-group text-teal flex-nowrap mb-3">
        <span class="col pl-0">{{ category.label }}</span>
        <span class="input-group-append align-items-center">
            <fa name="angle-right" [fixed]="false" size="lg" [ngClass]="{ 'fa-rotate-90': isPanelOpen(i) }"></fa>
        </span>
      </span>
    </ng-template>

    <ng-template ngbPanelContent>
      <div class="diy-category-content" [innerHtml]="category.overview"></div>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
`
}) // tslint:disable-next-line:component-class-suffix
export class DiyCategoryListAccordion {
  private openNgbPanelId: string = '';

  @Input() categories: { label: string; overview: string; }[];

  getPanelId(index: number): string {
    return `ngb-panel-${index}`;
  }

  onPanelChange(event) {
    this.openNgbPanelId = event.nextState ? event.panelId : '';

    if (this.openNgbPanelId.length > 0) {
      this.scrollIntoViewIfNot(document.getElementById(`${this.openNgbPanelId}-header`));
    }
  }

  isPanelOpen(ngbPanelIdOrIndex: string | number): boolean {
    const panelId = typeof ngbPanelIdOrIndex === 'number' ? this.getPanelId(ngbPanelIdOrIndex) : ngbPanelIdOrIndex;
    return this.openNgbPanelId === panelId;
  }

  private scrollIntoViewIfNot(element: HTMLElement): void {
    if (!element) {
      return;
    }

    const timeoutID = setTimeout(() => {
      clearTimeout(timeoutID);

      const rect = element.getBoundingClientRect();
      if (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
        /* element is already visible in viewport */
      } else {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0 /* as soon as possible */);
  }
}



// WEBPACK FOOTER //
// ./src/app/global/diy-category-list-accordion.ts